import { render, staticRenderFns } from "./PlaybackVideo.vue?vue&type=template&id=4037a1a5&scoped=true"
import script from "./PlaybackVideo.vue?vue&type=script&lang=js"
export * from "./PlaybackVideo.vue?vue&type=script&lang=js"
import style0 from "./PlaybackVideo.vue?vue&type=style&index=0&id=4037a1a5&prod&lang=css"
import style1 from "./PlaybackVideo.vue?vue&type=style&index=1&id=4037a1a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037a1a5",
  null
  
)

export default component.exports